<div id="heading-loading" *ngIf="loading">
    <i class="fas fa-spinner fa-spin"></i>
    <span>Cargando...</span>
</div>

<div id="heading-error" class="text-danger" *ngIf="!loading && error">
    <i class="fas fa-times"></i>
    <span>Error</span>
</div>

<div id="heading" class="m-3" *ngIf="!loading && !error">

    <div id="course-content-buttons" class="btn-group btn-group-toggle d-block text-end" data-toggle="buttons">
        <button class="btn btn-primary" (click)="changeEditing(!editing)">
            <div *ngIf="editing">
                <i class="fas fa-eye"></i>
                <span>Ver</span>
            </div>
            <div *ngIf="!editing">
                <i class="fas fa-edit"></i>
                <span>Editar</span>
            </div>
        </button>
    </div>

    <hr>

    <div id="heading-info-container">
        <h1 id="heading-name" class="mb-3" *ngIf="name">
            {{ name }}
        </h1>
        <p id="heading-unit" class="fw-bold mb-3">{{ unitName }}</p>
        <p id="heading-lesson" class="fw-bold mb-3">{{ lessonName }}</p>
    </div>

    <div id="heading-content-container" *ngIf="!editing">
        <div id="heading-multimedia-no-alt" class="alert alert-warning" role="alert" *ngIf="imgNoAlt">
            <p>La imagen insertada en este enunciado no tiene texto alternativo</p>
        </div>

        <div id="heading-multimedia-no-source" class="alert alert-warning" role="alert" *ngIf="imgNoSource">
            <p>La imagen insertada en este enunciado no tiene fuente / referencia complementaria</p>
        </div>

        <div id="heading-content" [innerHTML]="contentMedia" *ngIf="!contentEmpty"></div>

        <div id="heading-word-count" *ngIf="!contentEmpty">Palabras: {{ wordCount }}</div>
    
        <div id="heading-content-empty" *ngIf="contentEmpty">
            <p>No hay contenido.</p>
        </div>

        <div id="heading-term" *ngIf="term != null && term.length > 0">
            <p>Palabra clave: {{ term }}</p>
        </div>

        <div id="heading-diagram-btn">
            <hr>
            <button class="btn btn-primary" (click)="openDiagram()">
                <i class="fas fa-chart-diagram"></i>
                <i class="fas fa-eye"></i>
                <span>Diagrama</span>
            </button>
        </div>

        <div id="ai-features-container" *ngIf="userAI">
            <hr>

            <div id="generate-content-status" class="mb-3">
                <div id="generate-content-loading" *ngIf="generateContentLoading">
                    <i class="fas fa-spinner fa-spin"></i>
                    <span>Generando contenido...</span>
                </div>
                <div id="generate-content-success" class="text-success" *ngIf="generateContentSuccess">
                    <i class="fas fa-check"></i>
                    <span>¡Contenido generado correctamente!</span>
                </div>
                <div id="generate-content-error" class="text-danger" *ngIf="generateContentError">
                    <i class="fas fa-times"></i>
                    <span>Error</span>
                </div>
            </div>

            <div id="generate-image-status" class="mb-3">
                <div id="generate-image-loading" *ngIf="generateImageLoading">
                    <i class="fas fa-spinner fa-spin"></i>
                    <span>Generando imagen...</span>
                </div>
                <div id="generate-image-success" class="text-success" *ngIf="generateImageSuccess">
                    <i class="fas fa-check"></i>
                    <span>¡Imagen generada correctamente!</span>
                </div>
                <div id="generate-image-error" class="text-danger" *ngIf="generateImageError">
                    <i class="fas fa-times"></i>
                    <span>Error</span>
                </div>
            </div>

            <button class="btn btn-success d-block mb-3" *ngIf="heading" [attr.disabled]="generateContentLoading ? 'disabled' : null" (click)="generateContentAI()">
                <!-- <i class="fas fa-brain"></i> -->
                <i class="fas fa-wand-magic-sparkles"></i>
                <span>Generar contenido</span>
            </button>

            <button class="btn btn-success d-block mb-3" *ngIf="heading || caseStudy" [attr.disabled]="generateImageLoading ? 'disabled' : null" (click)="generateImageAI()">
                <!-- <i class="fas fa-brain"></i> -->
                <i class="fas fa-wand-magic-sparkles"></i>
                <span>Generar imagen para enunciado</span>
            </button>
        </div>

        <button class="btn btn-success d-block mb-3" *ngIf="heading || caseStudy" (click)="openRecommendMultimedia('image')">
            <i class="fas fa-photo-video"></i>
            <i class="fas fa-search"></i>
            <span>Recomendar multimedia para enunciados</span>
        </button>
    </div>
    
    <div id="heading-edit" class="mt-3" *ngIf="editing">
        <tinymce-editor [id]="headingContentEditorId" [content]="content" [course]="course" [lesson]="lesson" [heading]="id"></tinymce-editor>

        <div id="heading-content-buttons" class="my-3">
            <div class="mb-3 mx-0">
                <button id="multimedia-toggle-btn" class="btn btn-primary me-3" (click)="showMultimedia()">
                    <i class="fas fa-photo-video"></i>
                    <i class="fas fa-eye"></i>
                    <span>Ver multimedia</span>
                </button>

                <!--
                <button id="tables-toggle-btn" class="btn btn-primary me-3" (click)="tables = !tables; multimedia = false; files = false;" *ngIf="motoria">
                    <div *ngIf="!tables">
                        <i class="fas fa-table"></i>
                        <i class="fas fa-eye"></i>
                        <span>Ver tablas</span>
                    </div>
                    <div *ngIf="tables">
                        <i class="fas fa-table"></i>
                        <i class="fas fa-eye-slash"></i>
                        <span>Ocultar tablas</span>
                    </div>
                </button>
                -->

                <!-- 
                <button id="files-toggle-btn" class="btn btn-primary me-3" (click)="files = !files; multimedia = false; tables = false;">
                    <div *ngIf="!files">
                        <i class="fas fa-file"></i>
                        <i class="fas fa-eye"></i>
                        <span>Ver archivos</span>
                    </div>
                    <div *ngIf="files">
                        <i class="fas fa-file"></i>
                        <i class="fas fa-eye-slash"></i>
                        <span>Ocultar archivos</span>
                    </div>
                </button> 
                -->
            </div>

            <!--
            <div id="heading-tables" *ngIf="tables">
                <hr>
                <tables [courseID]="course" [parentType]="'lesson'" [parentID]="lesson"></tables>
                <hr>
            </div>
            -->

            <!--
            <div id="heading-files" *ngIf="files">
                <hr>
                <files [courseID]="course" [parentType]="'lesson'" [parentID]="lesson"></files>
                <hr>
            </div>
            -->
        </div>

        <button id="case-study-criteria-btn" class="btn btn-primary" (click)="showCriteria = !showCriteria">
            <div *ngIf="!showCriteria">
                <i class="fas fa-eye"></i>
                <span>Mostrar criterios asociados</span>
            </div>
            <div *ngIf="showCriteria">
                <i class="fas fa-eye-slash"></i>
                <span>Ocultar criterios asociados</span>
            </div>
        </button>
        
        <div id="case-study-criteria-container" class="mt-3" *ngIf="showCriteria">
            <p class="fw-bold">Criterios asociados:</p>
            <ul id="case-study-criteria" class="me-3">
                <li *ngFor="let crit of criteria">
                    <label>
                        <input type="checkbox" class="me-2" name="case_study_{{ id }}_criteria" id="case_study_{{ id }}_criteria_{{ crit.id }}" [value]="crit.id" [checked]="selectedCriteria.includes(crit.id)" (change)="checkCriteria($event)">
                        <span class="fw-bold me-1">{{ crit.code }}:</span>
                        <span>{{ crit.content }}</span>
                    </label>
                </li>
            </ul>
        </div>
    
        <div id="heading-summary-preview">
            <button id="heading-summary-preview-btn" class="btn btn-primary mt-3" (click)="preview(tinymceEditor.content)">
                <i class="fa fa-eye"></i>
                <span>Previsualizar cambios</span>
            </button>
        </div>
        
        <div id="heading-summary-save">
            <button id="heading-summary-save-btn" class="btn btn-success mt-3" (click)="update(id, tinymceEditor.content)">
                <i class="fas fa-save"></i>
                <span>Guardar cambios</span>
            </button>
        </div>
    </div>

</div>

<dialog id="heading-multimedia-dialog">
    <multimedia [courseID]="course" [parentType]="'lesson'" [parentID]="lesson" [dialog]="true"></multimedia>
</dialog>

<dialog id="heading-files-dialog">
    <files [courseID]="course" [parentType]="'lesson'" [parentID]="lesson" [dialog]="true"></files>
</dialog>

<dialog #diagramDialog id="heading-diagram-dialog">
    <ng-container *ngIf="diagram">
        <form method="dialog">
            <button class="btn-close float-end" (click)="closeDiagram()"></button>
        </form>
        <diagram [courseID]="course" [parentType]="type" [parentID]="id" [dialog]="true"></diagram>
        <form method="dialog">
            <button class="btn btn-danger mx-3" (click)="closeDiagram()">
                <i class="fas fa-times"></i>
                <span>Cerrar</span>
            </button>
        </form>
    </ng-container>
</dialog>

<dialog #headingRecommendMultimediaDialog id="heading-recommend-multimedia-dialog">
    <ng-container *ngIf="recommendMultimedia">
        <form method="dialog">
            <button class="btn-close float-end" (click)="closeRecommendMultimedia()"></button>
        </form>
        <recommend-multimedia [type]="recommendMultimediaType" [mode]="'heading'" [headingID]="id" [lessonID]="lesson" [keywords]="recommendMultimediaKeywords" [dialog]="true"></recommend-multimedia>
        <form method="dialog">
            <button class="btn btn-danger mx-3" (click)="closeRecommendMultimedia()">
                <i class="fas fa-times"></i>
                <span>Cerrar</span>
            </button>
        </form>
    </ng-container>
</dialog>